import { render, staticRenderFns } from "./tax-adjustfrm.vue?vue&type=template&id=0b9dfe3f"
import script from "./tax-adjustfrm.vue?vue&type=script&lang=js"
export * from "./tax-adjustfrm.vue?vue&type=script&lang=js"
import style0 from "./tax-adjustfrm.vue?vue&type=style&index=0&id=0b9dfe3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports